"use strict";
/*
 * Created on 01 16 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * ProductVATByProductConverter
 *
 * @author JMe
 */


var ProductVATByProductConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ProductVATByProductConverter, _DataObjectConverter_);

  function ProductVATByProductConverter() {
    _classCallCheck(this, ProductVATByProductConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductVATByProductConverter).apply(this, arguments));
  }

  return ProductVATByProductConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ProductVATByProductConverter = ProductVATByProductConverter;